{
    "XlU_owoEl_jVbf-7L6xai": {
        "key": "XlU_owoEl_jVbf-7L6xai",
        "position": {
            "x": 15,
            "y": 11,
            "z": 1
        },
        "tag": "spawn-good"
    },
    "nCHAhCtZnh5vcwWr5mTIJ": {
        "key": "nCHAhCtZnh5vcwWr5mTIJ",
        "position": {
            "x": 14,
            "y": 11,
            "z": 1
        },
        "tag": "spawn-good"
    },
    "_2DBC4ZTgKflTKolVpaOZ": {
        "key": "_2DBC4ZTgKflTKolVpaOZ",
        "position": {
            "x": 16,
            "y": 11,
            "z": 1
        },
        "tag": "spawn-good"
    },
    "5FN5rt_6eOYE-1MdUwhrk": {
        "key": "5FN5rt_6eOYE-1MdUwhrk",
        "position": {
            "x": 13,
            "y": 11,
            "z": 1
        },
        "tag": "spawn-good"
    },
    "4nfdUDe6W2nzWDAIxNY7d": {
        "key": "4nfdUDe6W2nzWDAIxNY7d",
        "position": {
            "x": 15,
            "y": 18,
            "z": 1
        },
        "tag": "spawn-bad"
    },
    "gVGOrgAvdt5Zm80K1NQN5": {
        "key": "gVGOrgAvdt5Zm80K1NQN5",
        "position": {
            "x": 10,
            "y": 18,
            "z": 1
        },
        "tag": "spawn-bad"
    },
    "A57FmLWGY0GKATto8ecA0": {
        "key": "A57FmLWGY0GKATto8ecA0",
        "position": {
            "x": 14,
            "y": 18,
            "z": 1
        },
        "tag": "spawn-bad"
    },
    "qBLUN4Ks9jAcBM96F9HZi": {
        "key": "qBLUN4Ks9jAcBM96F9HZi",
        "position": {
            "x": 19,
            "y": 18,
            "z": 1
        },
        "tag": "spawn-bad"
    }
}